import KeyAttributes from'./KeyAttributes';export default KeyAttributes;